import { useState } from "react";
import { navLinks } from "@/mocks/nanaData";

export default function Footer() {
  const [year] = useState(new Date().getFullYear());

  const goTo = (href: string) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-secondary-50 px-4 pb-8 pt-12 md:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 border-b border-secondary-200/70 pb-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-[ZCOOL_KuaiLe] text-xl text-foreground-950">
                娜娜51<span className="text-primary-500">热评圈</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一站聚合贴吧、知乎、论坛与热搜上的「娜娜51」相关热议话题，围观网友观点，理性吃瓜，友好讨论。
            </p>
            <p className="mt-4 text-xs text-foreground-400">商务与媒体合作：hello@nana51-reyi.example</p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">快速导航</h3>
            <ul className="mt-3 space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      goTo(link.href);
                    }}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">围观守则</h3>
            <ul className="mt-3 space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-secondary-600"></i>理性吃瓜，不传谣
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-secondary-600"></i>友好表达，不攻击
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-secondary-600"></i>尊重隐私，守边界
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-secondary-600"></i>如实转述，不曲解
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">
            © {year} 娜娜51热评圈 · 本站聚合内容均整理自各平台网友公开讨论，版权归原作者所有。
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="返回顶部"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-200 text-secondary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            <i className="ri-arrow-up-line"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}